var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSanscript(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 24.496,
    viewBox: "0 0 27 24.496",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.5 -3.748)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1020.362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5,1030.61a5.02,5.02,0,0,1,5,5,4.931,4.931,0,0,1-.924,2.867.5.5,0,0,0,.281.774,5.878,5.878,0,0,0,1.812.258,3.12,3.12,0,0,0,1.664-.557,6.885,6.885,0,0,0,1.779-2.1l.006-.01a1.012,1.012,0,0,1,.078-.115,5.643,5.643,0,0,1,4.3-2.117c3.421,0,6,3.242,6,7s-2.579,7-6,7a5.641,5.641,0,0,1-4.3-2.115.921.921,0,0,1-.25-.77,1.1,1.1,0,0,1,1.074-.895.925.925,0,0,1,.711.383,3.609,3.609,0,0,0,2.768,1.4c2.136,0,4-2.146,4-5s-1.864-5-4-5a3.612,3.612,0,0,0-2.768,1.4.536.536,0,0,0-.037.051c-1.483,2.32-3.251,3.34-4.9,3.439h-.078a.5.5,0,0,0-.459.646,4.911,4.911,0,0,1,.242,1.461,5,5,0,0,1-4.969,5H9.469a6.985,6.985,0,0,1-6.969-6.969s0-.007,0-.01a.92.92,0,0,1,.295-.762,1.106,1.106,0,0,1,1.41,0,.919.919,0,0,1,.295.762s0,.007,0,.01a4.958,4.958,0,0,0,4.969,4.969h1.063a3,3,0,0,0,0-6,.986.986,0,0,1-.287-.041.5.5,0,0,0-.2-.018c-.231.025-.406.059-.547.059H9.494a.906.906,0,0,1-.762-.295,1.1,1.1,0,0,1,0-1.408.92.92,0,0,1,.762-.3H9.5a3,3,0,1,0-2.119-5.119l-.008.01a.921.921,0,0,1-.748.338,1.115,1.115,0,0,1-1-1,.917.917,0,0,1,.334-.748l.006-.01a5.013,5.013,0,0,1,3.537-1.471Z",
    fill: "#0080ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.685,1026.61c1.262,3.281,3.836,5.389,6.709,5.5a6.535,6.535,0,0,0,3.791-1.087l-1.041-2.346a8.265,8.265,0,0,1-3.577.644,8.9,8.9,0,0,1-5.883-2.708Z",
    fill: "#0080ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.685,1025.91l1.2-1.8,1.8,1.2-1.2,1.8Z",
    fill: "#0080ff",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSanscript);
export default __webpack_public_path__ + "static/media/sanscript.97f9b803.svg";
export { ForwardRef as ReactComponent };